import React from "react";
import { AlertTriangle, Landmark } from "lucide-react";

export function DigiLockerBadge({ id }) {
  return (
    <span
      className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-bold uppercase tracking-wider bg-[#0A2540] text-[#D4AF37]"
      data-testid={`kyc-source-digilocker-${id}`}
      title="Fetched from DigiLocker (issuer-signed)"
    >
      <Landmark size={10} /> DigiLocker
    </span>
  );
}

export function ManualBadge({ id }) {
  return (
    <span
      className="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-bold uppercase tracking-wider bg-slate-100 text-slate-600"
      data-testid={`kyc-source-manual-${id}`}
    >
      Manual upload
    </span>
  );
}

export function NameMismatchWarning({ id, documentName, registeredName, compact = false }) {
  return (
    <div
      className={`rounded-xl border border-amber-300 bg-amber-50 text-amber-900 ${compact ? "px-3 py-2 text-xs" : "p-3 text-sm"}`}
      data-testid={`kyc-name-mismatch-${id}`}
      role="alert"
    >
      <p className="font-bold inline-flex items-center gap-1"><AlertTriangle size={compact ? 12 : 14} /> Name mismatch</p>
      <p className="mt-1">
        Registered name: <strong data-testid={`kyc-name-registered-${id}`}>{registeredName || "—"}</strong>
        <span className="mx-2 text-amber-400">|</span>
        DigiLocker name: <strong data-testid={`kyc-name-digilocker-${id}`}>{documentName || "—"}</strong>
      </p>
      <p className="mt-1 text-amber-800/90">Please verify before approving this document.</p>
    </div>
  );
}
